<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold mb-0">Scheduled Reports</h3>
            <small class="text-muted">
              Automated report generation schedule
            </small>
          </div>

          <div class="d-flex align-items-center">
            <b-button variant="primary" class="text-nowrap" size="sm">
              <feather-icon icon="PlusIcon" />
              Add Schedule
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12">
        <b-card class="shadow-sm" body-class="p-0">
          <h5 class="card-header-custom">Active Schedules</h5>
          <div
            v-for="(item, index) in schedules"
            :key="index"
            class="schedule-item d-flex justify-content-between align-items-center"
          >
            <!-- LEFT -->
            <div>
              <div class="font-weight-semibold">
                {{ item.title }}
              </div>
              <small class="text-muted d-flex align-items-center">
                <span class="status-dot mr-1"></span>
                {{ item.sub }}
              </small>
            </div>

            <!-- RIGHT -->
            <div class="d-flex align-items-center">
              <b-button
                size="sm"
                variant="outline-secondary"
                class="icon-btn mr-1"
              >
                <feather-icon icon="Edit2Icon" size="14" />
              </b-button>

              <b-button size="sm" variant="outline-danger" class="icon-btn">
                <feather-icon icon="Trash2Icon" size="14" />
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
  BContainer,
} from "bootstrap-vue";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
  },
  data() {
    return {
      schedules: [
        {
          title: "Daily All Bets Export",
          sub: "Every day at 6:00 AM • CSV",
        },
        {
          title: "Regulatory NSW Daily",
          sub: "Every day at 6:00 AM • Auto-submit",
        },
        {
          title: "Weekly GGR Summary",
          sub: "Every Monday at 8:00 AM • Excel",
        },
        {
          title: "Monthly BDM Commissions",
          sub: "1st of month at 9:00 AM • Excel",
        },
      ],
    };
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.card-header-custom {
  padding: 16px 20px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
}

.schedule-item {
  padding: 16px 20px;
  border-bottom: 1px solid #f2f2f2;
}

.schedule-item:last-child {
  border-bottom: none;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
}

.icon-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>